export default {
  // Textos específicos de Faculty
  color: 'Color',
  generalEducationFaculty: 'de Formación General',
  generalEducationTooltip: 'Permite que las {subjects} de la {faculty} sean de Formación General.',
  yes: 'Sí',
  no: 'No',
  isGeneralEducation: 'Esta {faculty} es de Formación General',
  selectImagePlaceholder: 'Seleccione o arrastre la imagen aquí...',
  dropImagePlaceholder: 'Arrastre la imagen aquí...',
  cannotDelete: 'No se puede eliminar la {faculty} si cuenta con {programs} asignado',
}
